<template>
  <div class="row">
    <v-btn v-show="step !== 1" @click="handlePrev" class="btn-return">
      <i class="fas fa-arrow-left mr-2 text-twenty"></i>Voltar</v-btn
    >
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <Care :group_prescription_care="group_prescription_care" />
    </div>
    <div
      v-show="step == 1"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label>DATA DE REGISTRO</label>
          <input
            disabled
            :value="formatDate(moment().format('YYYY-MM-DD'), false)"
            class="form-control"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label>HORÁRIO</label>
          <input
            disabled
            :value="
              prescription_care_time.time
                ? String(prescription_care_time.time).substr(0, 5)
                : 'EVENTUAL'
            "
            class="form-control"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <v-btn
            outlined
            :class="[
              'btn-block m-1',
              !checked && '',
              checked != 'NAO' && '',
              checked == 'NAO' && 'btn-atrasado',
            ]"
            @click="handleNotDone"
          >
            <i class="fas fa-times mr-1"></i> NÃO REALIZADO</v-btn
          >
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <v-btn
            :disabled="!care_check.separate_checked"
            outlined
            :class="[
              'btn-block m-1',
              !checked && '',
              checked != 'SIM' && '',
              checked == 'SIM' && 'btn-checado',
            ]"
            @click="handleDone"
          >
            <i class="fas fa-check mr-2 text-twenty"></i> REALIZADO
          </v-btn>
        </div>
        <div
          v-show="checked == 'NAO'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <label>MOTIVO:</label>
          <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="note" />
        </div>
        <div
          v-show="care_check.stocked_item_id"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <label>ESTOQUE</label>
          <input
            v-if="
              care_check.resident_has_stocked_item &&
              care_check.resident_has_stocked_item.stock_group_name
            "
            disabled
            type="text"
            :value="`${care_check.resident_has_stocked_item.resident_name} - ${care_check.resident_has_stocked_item.stock_group_name}`"
            class="form-control"
          />
          <input
            v-if="
              !care_check.resident_has_stocked_item ||
              !care_check.resident_has_stocked_item.stock_group_name
            "
            disabled
            type="text"
            value="ESTOQUE NÃO ENCONTRADO"
            class="form-control"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
    <div
      v-if="step == 2 && show_justification"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
    >
      JUSTIFICATIVA DA CHECAGEM COM ATRASO
      <ChromeSpeechToTextTextarea rows="3" v-model="justification" />
    </div>
    <div
      v-show="step == 2"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center back-ground-grey"
    >
      <h6 class="mb-0">FINALIZAR</h6>
      <div class="p-2" v-if="check_anticipated">
        <label>MOTIVO:</label>
        <ChromeSpeechToTextTextarea
          rows="3"
          max-rows="10"
          v-model="note_anticipated"
        />
      </div>
      <div class="mt-2 v-dark v-clean pt-2 pb-2" v-if="check_anticipated">
        <span
          v-if="
            group_prescription_care.prescription_care.frequency != 'EVENTUAL'
          "
        >
          O cuidado é do horário das
          {{
            prescription_care_time.time
              ? String(prescription_care_time.time).substr(0, 5)
              : "--:--"
          }}
          horas, tem
        </span>
        <span
          v-if="
            group_prescription_care.prescription_care.frequency == 'EVENTUAL'
          "
          >Tem</span
        >
        certeza que deseja realizar a adminstração desse cuidado?
        <v-btn
          :disabled="loading"
          @click="handleCheckAnticipated"
          class="btn-one-finish-certified mt-2 p-2 noBorderRadius"
        >
          <i class="fas fa-check mr-2 text-twenty"></i> FINALIZAR MANUAL
          {{ loading ? "CARREGANDO" : "COM ASSINATURA ELETRÔNICA" }}
        </v-btn>
      </div>
      <div class="mt-1">
        <ErrorsMessages :errors="errors" />
      </div>
    </div>
    <div
      v-if="step == 2 && !check_anticipated"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
    >
      <v-btn :disabled="loading" @click="handleNext" class="btn-notcertified">
        FINALIZAR MANUAL
        {{ loading ? "CARREGANDO" : "COM ASSINATURA ELETRÔNICA" }}
      </v-btn>
    </div>
    <div
      v-if="step == 1"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between"
    >
      <v-btn
        @click="$emit('cancel')"
        class="btn-modern btn-modern-delete"
        type="relief"
        >CANCELAR</v-btn
      >
      <v-btn
        :disabled="loading ? true : false"
        @click="handleNext"
        class="btn-modern btn-modern-save"
      >
        {{ loading ? "CARREGANDO" : "AVANÇAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import Care from "../Care";

import { formatDate, formatDateOnlyNumbers } from "../../../../lib/format";

import { userData } from "../../../../lib/functions";

import moment from "moment";

import routes from "../../../../routes";

export default {
  name: "Check",
  components: {
    Care,
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
  },
  props: {
    date: [String, Number],
    group_prescription_care: Object,
    prescription_care_time: Object,
    care_check: Object,
    stock_id: [String, Number],
  },
  data() {
    return {
      rest_home_id: "",
      resident_id: "",
      stocked_item_id: "",
      loading: false,
      checked: false,
      despised: false,
      other_stock: false,
      note: "",
      note_anticipated: "",
      show_justification: false,
      check_anticipated: false,
      confirm_check_anticipated: false,
      justification: "",
      step: 1,
      errors: [],
      stock_group: [],
      enough_stocks: [],
      stocksByCare: [],
      stocksResidentByCare: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatDate,
    async retrieve() {
      this.show_justification = false;
      this.check_anticipated = false;
      this.confirm_check_anticipated = false;

      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { group_prescription_care, date } = this;

      let { stocked_item_id } = group_prescription_care.care_check;
      this.stocked_item_id = stocked_item_id;

      if (!group_prescription_care.care_check.separate_checked) {
        this.checked = "NAO";
      }

      if (
        parseInt(formatDateOnlyNumbers(date)) <
        parseInt(formatDateOnlyNumbers(new Date()))
      ) {
        this.show_justification = true;
      }
    },
    handleNotDone() {
      this.checked = "NAO";
      this.despised = false;
    },
    handleDone() {
      this.checked = "SIM";
      this.despised = false;
      this.note = "";
    },
    handlePrev() {
      let { step } = this;

      if (step == 2) {
        this.step = step - 1;
      }
    },
    handleNext() {
      this.confirm_check_anticipated = false;

      let { step, note, checked } = this;

      if (step == 1) {
        if (!checked) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe se foi REALIZADO ou NÃO REALIZADO",
            },
          ];
          return;
        }

        if (checked == "NAO") {
          if (!String(note).trim() || !note) {
            this.errors = [
              {
                id: this.errors.length,
                message: "Informe o motivo",
              },
            ];
            return;
          }
        }

        this.errors = [];
        this.step = step + 1;
      }

      if (step == 2) {
        this.check();
        return;
      }
    },
    handleCheckAnticipated() {
      let { note_anticipated } = this;

      if (!note_anticipated || !String(note_anticipated).trim()) {
        this.confirm_check_anticipated = false;
        this.loading = false;
        this.errors = ["Informe o motivo"];
        return;
      }

      this.confirm_check_anticipated = true;
      this.check();
    },
    async check() {
      try {
        this.loading = true;
        this.check_anticipated = false;

        let {
          resident_id,
          care_check: { id },
          stock_id,
          checked,
          note,
          despised,
          date,
          show_justification,
          justification,
          confirm_check_anticipated,
          note_anticipated,
        } = this;

        let params = {
          resident_id,
          id,
          stock_id,
          checked,
          note,
          despised,
          date,
          justification,
          confirm_check_anticipated,
          note_anticipated,
        };

        if (show_justification) {
          if (!justification || !String(justification).trim()) {
            this.loading = false;
            this.errors = [{ id: 1, message: "Informe a justificativa" }];
            return;
          }
        }

        const response = await api.post("/rest-home/check/check-care", params);

        const { error, errors, check_anticipated, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$emit("checked");
          this.errors = [];
        } else {
          if (check_anticipated) {
            this.errors = [];
            this.check_anticipated = true;
          } else {
            this.errors = errors;
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
